import { Field } from 'formik';
import { useIntl } from 'react-intl';
import { FieldProps } from '../../../types/fields';
import { config } from '../../../utils/config';
import { Country } from '../../../utils/countryData';
import getZipCodeValidator from '../../../utils/getZipCodeCityValidator';
import SelectField from '../../formik/SelectField';
import TextField from '../../formik/TextField';
import useZipCodeValidation from './useZipCodeValidation';

type ZipCodeFieldProps = FieldProps & { country: Country; onBlur: () => void; suggestedZipCodes?: string[] };

const ZipCodeField = ({ context, testIdPrefix, country, onBlur, suggestedZipCodes }: ZipCodeFieldProps) => {
  const { formatMessage } = useIntl();
  const { zipCode: zipCodeConfig } = config.addressForm[country].zipCodeCity;

  const showZipCodeField = zipCodeConfig.enabled === undefined || zipCodeConfig.enabled;
  const showSelectField = zipCodeConfig.completion?.enabled && suggestedZipCodes?.length;
  const selectFieldOptions = suggestedZipCodes?.map(zip => ({ value: zip, label: zip }));
  const zipCodeValidation = useZipCodeValidation(country);

  if (!showZipCodeField) {
    return null;
  }

  return (
    <div className="form__field-container">
      <Field
        onBlur={onBlur}
        name={[context, 'zipCode'].filter(Boolean).join('.')}
        component={showSelectField ? SelectField : TextField}
        options={selectFieldOptions}
        label={formatMessage({ id: 'address.zipCode' })}
        maxLength={zipCodeConfig.maxLength ?? 8}
        validate={getZipCodeValidator({
          required: true,
          minLength: 3,
          format: 'default',
          ...zipCodeValidation,
        })}
        data-test-id={`${testIdPrefix}-zipCode`}
      />
    </div>
  );
};

export default ZipCodeField;
